var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative w-full" }, [
    _c(
      "div",
      { staticClass: "bg-white rounded-lg shadow-sm p-2 flex items-center" },
      [
        _c("div", { staticClass: "bg-indigo-100 p-2 rounded-full mr-3" }, [
          _c(
            "svg",
            {
              staticClass: "h-5 w-5 text-indigo-600",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchQuery,
              expression: "searchQuery"
            }
          ],
          staticClass: "transition-all duration-300 focus:outline-none",
          class: {
            "w-full": _vm.isSearchFocused,
            "w-64": !_vm.isSearchFocused
          },
          attrs: {
            type: "text",
            placeholder: "Ask about your dashboard data...",
            disabled: _vm.isLoading
          },
          domProps: { value: _vm.searchQuery },
          on: {
            focus: function($event) {
              _vm.isSearchFocused = true
            },
            blur: _vm.handleBlur,
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleSearchSubmit($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchQuery = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "ml-2 bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed",
            attrs: { disabled: _vm.isLoading || !_vm.searchQuery.trim() },
            on: { click: _vm.handleSearchSubmit }
          },
          [
            _c("span", { staticClass: "hidden sm:inline" }, [
              _vm._v(_vm._s(_vm.isLoading ? "Asking..." : "Ask AI"))
            ]),
            _vm._v(" "),
            !_vm.isLoading
              ? _c(
                  "svg",
                  {
                    staticClass: "ml-2 h-4 w-4",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }
                  },
                  [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
                )
              : _c("div", {
                  staticClass:
                    "ml-2 w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                })
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.showAIResponse
      ? _c("div", { staticClass: "absolute inset-x-0 top-full mt-2 z-50" }, [
          _c(
            "div",
            {
              staticClass:
                "bg-white rounded-lg shadow-lg border border-gray-200"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex justify-between items-center p-4 border-b border-gray-200"
                },
                [
                  _c("div", { staticClass: "flex items-center" }, [
                    _c(
                      "div",
                      { staticClass: "bg-indigo-100 p-2 rounded-full mr-3" },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-4 w-4 text-indigo-600",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M12 3l1.88 5.76h6.12l-4.94 3.59 1.88 5.76-4.94-3.59-4.94 3.59 1.88-5.76-4.94-3.59h6.12z"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h3", { staticClass: "font-medium text-gray-800" }, [
                      _vm._v("AI Assistant")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1 rounded-md text-sm mr-2",
                        on: { click: _vm.startNewChat }
                      },
                      [_vm._v("\n            New Chat\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "text-gray-400 hover:text-gray-600",
                        on: {
                          click: function($event) {
                            _vm.showAIResponse = false
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }
                          },
                          [
                            _c("line", {
                              attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "messageContainer",
                  staticClass: "h-64 overflow-y-auto p-4"
                },
                _vm._l(_vm.chatMessages, function(message, index) {
                  return _c("div", { key: index, staticClass: "mb-4" }, [
                    message.sender === "ai"
                      ? _c("div", { staticClass: "flex items-start mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-indigo-100 p-2 rounded-full mr-3 flex-shrink-0"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "h-4 w-4 text-indigo-600",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M12 3l1.88 5.76h6.12l-4.94 3.59 1.88 5.76-4.94-3.59-4.94 3.59 1.88-5.76-4.94-3.59h6.12z"
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-white rounded-lg p-4 shadow-sm max-w-3xl"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-700 whitespace-pre-wrap"
                                },
                                [_vm._v(_vm._s(message.text))]
                              )
                            ]
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "flex items-start justify-end mb-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-indigo-600 rounded-lg p-4 shadow-sm max-w-3xl"
                              },
                              [
                                _c("p", { staticClass: "text-white" }, [
                                  _vm._v(_vm._s(message.text))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(0, true)
                          ]
                        ),
                    _vm._v(" "),
                    message.sender === "loading"
                      ? _c("div", { staticClass: "flex items-start mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-indigo-100 p-2 rounded-full mr-3 flex-shrink-0"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "h-4 w-4 text-indigo-600",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M12 3l1.88 5.76h6.12l-4.94 3.59 1.88 5.76-4.94-3.59-4.94 3.59 1.88-5.76-4.94-3.59h6.12z"
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(1, true)
                        ])
                      : _vm._e()
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "border-t border-gray-200 p-4 flex items-center"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.followUpQuery,
                        expression: "followUpQuery"
                      }
                    ],
                    staticClass:
                      "flex-grow px-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500",
                    attrs: {
                      type: "text",
                      placeholder: "Type a follow-up question...",
                      disabled: _vm.isLoading
                    },
                    domProps: { value: _vm.followUpQuery },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFollowUpSubmit($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.followUpQuery = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "ml-2 p-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed",
                      attrs: {
                        disabled: _vm.isLoading || !_vm.followUpQuery.trim()
                      },
                      on: { click: _vm.handleFollowUpSubmit }
                    },
                    [
                      !_vm.isLoading
                        ? _c(
                            "svg",
                            {
                              staticClass: "h-5 w-5",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2"
                              }
                            },
                            [
                              _c("path", { attrs: { d: "M22 2L11 13" } }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: { d: "M22 2l-7 20-4-9-9-4 20-7z" }
                              })
                            ]
                          )
                        : _c("div", {
                            staticClass:
                              "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
                          })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "border-t border-gray-200 px-4 py-2 text-xs text-gray-500 flex justify-between"
                },
                [
                  _c("span", [
                    _vm._v(
                      "Based on your dashboard data • " +
                        _vm._s(new Date().toLocaleDateString())
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-indigo-600 cursor-pointer hover:underline",
                      on: { click: _vm.exportConversation }
                    },
                    [_vm._v("Export conversation")]
                  )
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bg-indigo-100 p-2 rounded-full ml-3 flex-shrink-0" },
      [
        _c("span", { staticClass: "text-indigo-600 text-sm font-medium" }, [
          _vm._v("You")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bg-white rounded-lg p-4 shadow-sm max-w-3xl" },
      [
        _c("div", { staticClass: "flex items-center space-x-2" }, [
          _c("div", { staticClass: "flex space-x-1" }, [
            _c("div", {
              staticClass: "w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "w-2 h-2 bg-indigo-600 rounded-full animate-bounce",
              staticStyle: { "animation-delay": "0.1s" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "w-2 h-2 bg-indigo-600 rounded-full animate-bounce",
              staticStyle: { "animation-delay": "0.2s" }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text-gray-500 text-sm" }, [
            _vm._v("AI is thinking...")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ee5f136", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ee5f136","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AISearch/SearchBar.vue
// module id = null
// module chunks = 